// extracted by mini-css-extract-plugin
export default {"container":"container_vsmlN","titleText":"titleText_pXYpl","tags":"tags_Yk3O1"};